import React, { useState, useEffect, useRef } from "react";
import ArrowDown from "../assets/icons/ArrowDown";
import { get,post } from "../network/api";
import {usePlaceOrder} from "../context/OrderContext"
import { useTranslation } from "react-i18next";

const AddressDropdown = ({
  selectedAddress,
  setSelectedAddress,
  onAddAddress,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [addresses, setAddresses] = useState([

  ]);
  const { t } = useTranslation();
  const dropdownRef = useRef(null); // Ref for the dropdown container

  // get address and set
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { order,setDeliveryCost,setDeliveryAddress } = usePlaceOrder();
  

  async function getAddress() {
    try {
      const data = await get("customer/address/get-address");
      setAddresses(data);
      setLoading(false);
    } catch (e) {
      // setError(error.message); // Handle any errors
      setLoading(false);
    }
  }
  async function getDeliveryCost(address) {
    try {
      
      const data = await post("customer/calculate-delivery-cost", {
        'restaurant_id': order.restaurant._id,
        'address_id':address._id 
      });
      
      setDeliveryCost(data.delivery_cost)


    } catch (e) {
      console.log(e)
      setError(e.message); // Handle any errors
      setLoading(false);
    }
  }
  



  useEffect(() => {
    getAddress();
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false); // Close dropdown if the click is outside
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick); // Cleanup event listener
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSelectAddress = (address) => {
    setSelectedAddress(address);
    getDeliveryCost(address);
    setIsDropdownOpen(false); // Close the dropdown after selection
    
  };

  const handleAddAddressClick = () => {
    onAddAddress(); // Open the modal for adding a new address
    setIsDropdownOpen(false);
  };

  return (
    <div className="address-dropdown" ref={dropdownRef}>
      <div className="summary-item" onClick={toggleDropdown}>
        <div className="flex-item">
          <strong>{t('delivery_address')}: </strong>
          <p>{selectedAddress?.formatted_address || selectedAddress?.address|| t('select_address')}</p>
        </div>
        <span className="arrow">
          <ArrowDown />
        </span>
      </div>
      {isDropdownOpen && (
        <div className="dropdown-list">
          <div className="dropdown-item">
            <strong>{t('select_address')}</strong>
          </div>
          {addresses.map((address, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleSelectAddress(address)}
            >
              {address?.formatted_address}
            </div>
          ))}
          <div className="dropdown-item" onClick={handleAddAddressClick}>
            <strong>+ {t('add_new_address')}</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressDropdown;
